// <auto-generated>
// This file is automatically generated by the CLI.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2025-11-13T19:25:50.901Z
// </auto-generated>

import { areaService } from '@/services/core/AreaService';
import { areaTypeService } from '@/services/core/AreaTypeService';
import { assignmentPolicyService } from '@/services/core/AssignmentPolicyService';
import { batchJobService } from '@/services/core/BatchJobService';
import { batchJobRunService } from '@/services/core/BatchJobRunService';
import { businessRuleService } from '@/services/core/BusinessRuleService';
import { companyProfileService } from '@/services/core/CompanyProfileService';
import { countryService } from '@/services/core/CountryService';
import { currencyService } from '@/services/core/CurrencyService';
import { deliveryTermsService } from '@/services/core/DeliveryTermsService';
import { documentPageSetupService } from '@/services/core/DocumentPageSetupService';
import { documentTemplateService } from '@/services/core/DocumentTemplateService';
import { entityTemplateService } from '@/services/core/EntityTemplateService';
import { enumValueService } from '@/services/core/EnumValueService';
import { fieldRestrictionSetService } from '@/services/core/FieldRestrictionSetService';
import { lldDistrictService } from '@/services/core/LldDistrictService';
import { numberSeriesService } from '@/services/core/NumberSeriesService';
import { orgRoleFunctionService } from '@/services/core/OrgRoleFunctionService';
import { orgUnitService } from '@/services/core/OrgUnitService';
import { ownerDerivationRuleService } from '@/services/core/OwnerDerivationRuleService';
import { paymentTermsService } from '@/services/core/PaymentTermsService';
import { receivingLocationService } from '@/services/core/ReceivingLocationService';
import { setupPackageService } from '@/services/core/SetupPackageService';
import { tradeTypeService } from '@/services/core/TradeTypeService';
import { unitOfMeasureService } from '@/services/core/UnitOfMeasureService';
import { accountService } from '@/services/finance/AccountService';
import { accountDerivationRuleService } from '@/services/finance/AccountDerivationRuleService';
import { accountDimensionRuleService } from '@/services/finance/AccountDimensionRuleService';
import { dimensionDefinitionService } from '@/services/finance/DimensionDefinitionService';
import { dimensionSetService } from '@/services/finance/DimensionSetService';
import { dimensionValueService } from '@/services/finance/DimensionValueService';
import { distributionProfileService } from '@/services/finance/DistributionProfileService';
import { fiscalPeriodService } from '@/services/finance/FiscalPeriodService';
import { fiscalYearService } from '@/services/finance/FiscalYearService';
import { planHeaderService } from '@/services/finance/PlanHeaderService';
import { planLineService } from '@/services/finance/PlanLineService';
import { planLineReevaluationRunService } from '@/services/finance/PlanLineReevaluationRunService';
import { planLineReevaluationRunItemService } from '@/services/finance/PlanLineReevaluationRunItemService';
import { planLineSnapshotService } from '@/services/finance/PlanLineSnapshotService';
import { planScenarioService } from '@/services/finance/PlanScenarioService';
import { planStatementTemplateService } from '@/services/finance/PlanStatementTemplateService';
import { planVersionService } from '@/services/finance/PlanVersionService';
import { planVersionPublishRunService } from '@/services/finance/PlanVersionPublishRunService';
import { planViewService } from '@/services/finance/PlanViewService';
import { vatCodeService } from '@/services/finance/VatCodeService';
import { agreementService } from '@/services/forestry/AgreementService';
import { calculationComponentService } from '@/services/forestry/CalculationComponentService';
import { calculationTemplateService } from '@/services/forestry/CalculationTemplateService';
import { contractService } from '@/services/forestry/ContractService';
import { costTypeService } from '@/services/forestry/CostTypeService';
import { loadObservationService } from '@/services/forestry/LoadObservationService';
import { organizationService } from '@/services/forestry/OrganizationService';
import { preCalculationService } from '@/services/forestry/PreCalculationService';
import { priceAreaAssortmentService } from '@/services/forestry/PriceAreaAssortmentService';
import { priceDimensionService } from '@/services/forestry/PriceDimensionService';
import { priceDimensionClassCombinationService } from '@/services/forestry/PriceDimensionClassCombinationService';
import { volumeBasisLineService } from '@/services/forestry/VolumeBasisLineService';
import { workorderService } from '@/services/forestry/WorkorderService';
import { importProfileService } from '@/services/integration/ImportProfileService';
import { integrationCallRecordService } from '@/services/integration/IntegrationCallRecordService';
import { integrationClientService } from '@/services/integration/IntegrationClientService';
import { integrationConnectionService } from '@/services/integration/IntegrationConnectionService';
import { integrationJobService } from '@/services/integration/IntegrationJobService';
import { integrationOutboxRecordService } from '@/services/integration/IntegrationOutboxRecordService';
import { integrationRunService } from '@/services/integration/IntegrationRunService';
import { integrationRunDetailService } from '@/services/integration/IntegrationRunDetailService';
import { integrationRunErrorService } from '@/services/integration/IntegrationRunErrorService';
import { integrationStagingRecordService } from '@/services/integration/IntegrationStagingRecordService';
import { inventoryOnHandService } from '@/services/inventory/InventoryOnHandService';
import { inventoryPeriodCloseService } from '@/services/inventory/InventoryPeriodCloseService';
import { inventoryPostingProfileService } from '@/services/inventory/InventoryPostingProfileService';
import { inventoryReservationService } from '@/services/inventory/InventoryReservationService';
import { inventoryTransactionService } from '@/services/inventory/InventoryTransactionService';
import { inventoryValueEntryService } from '@/services/inventory/InventoryValueEntryService';
import { inventoryVarianceEntryService } from '@/services/inventory/InventoryVarianceEntryService';
import { productService } from '@/services/inventory/ProductService';
import { standardCostVersionService } from '@/services/inventory/StandardCostVersionService';
import { internalPriceListService } from '@/services/pricing/InternalPriceListService';
import { priceListService } from '@/services/pricing/PriceListService';
import { inboundMeasuringTicketService } from '@/services/procurement/InboundMeasuringTicketService';
import { supplierService } from '@/services/procurement/SupplierService';
import { customerService } from '@/services/sales/CustomerService';
import { customerGroupService } from '@/services/sales/CustomerGroupService';
import { invoiceService } from '@/services/sales/InvoiceService';
import { orderService } from '@/services/sales/OrderService';
import { orderLineService } from '@/services/sales/OrderLineService';
import { workTaskService } from '@/services/taskmanagement/WorkTaskService';
import { approvalDelegationService } from '@/services/workflow/ApprovalDelegationService';
import { approvalPolicyService } from '@/services/workflow/ApprovalPolicyService';
import { approvalRequestService } from '@/services/workflow/ApprovalRequestService';

/**
 * Service Registry
 * Maps module.entity to service instances for dynamic lookup
 */
const serviceRegistry = {
  'core.Area': areaService,
  'core.AreaType': areaTypeService,
  'core.AssignmentPolicy': assignmentPolicyService,
  'core.BatchJob': batchJobService,
  'core.BatchJobRun': batchJobRunService,
  'core.BusinessRule': businessRuleService,
  'core.CompanyProfile': companyProfileService,
  'core.Country': countryService,
  'core.Currency': currencyService,
  'core.DeliveryTerms': deliveryTermsService,
  'core.DocumentPageSetup': documentPageSetupService,
  'core.DocumentTemplate': documentTemplateService,
  'core.EntityTemplate': entityTemplateService,
  'core.EnumValue': enumValueService,
  'core.FieldRestrictionSet': fieldRestrictionSetService,
  'core.LldDistrict': lldDistrictService,
  'core.NumberSeries': numberSeriesService,
  'core.OrgRoleFunction': orgRoleFunctionService,
  'core.OrgUnit': orgUnitService,
  'core.OwnerDerivationRule': ownerDerivationRuleService,
  'core.PaymentTerms': paymentTermsService,
  'core.ReceivingLocation': receivingLocationService,
  'core.SetupPackage': setupPackageService,
  'core.TradeType': tradeTypeService,
  'core.UnitOfMeasure': unitOfMeasureService,
  'finance.Account': accountService,
  'finance.AccountDerivationRule': accountDerivationRuleService,
  'finance.AccountDimensionRule': accountDimensionRuleService,
  'finance.DimensionDefinition': dimensionDefinitionService,
  'finance.DimensionSet': dimensionSetService,
  'finance.DimensionValue': dimensionValueService,
  'finance.DistributionProfile': distributionProfileService,
  'finance.FiscalPeriod': fiscalPeriodService,
  'finance.FiscalYear': fiscalYearService,
  'finance.PlanHeader': planHeaderService,
  'finance.PlanLine': planLineService,
  'finance.PlanLineReevaluationRun': planLineReevaluationRunService,
  'finance.PlanLineReevaluationRunItem': planLineReevaluationRunItemService,
  'finance.PlanLineSnapshot': planLineSnapshotService,
  'finance.PlanScenario': planScenarioService,
  'finance.PlanStatementTemplate': planStatementTemplateService,
  'finance.PlanVersion': planVersionService,
  'finance.PlanVersionPublishRun': planVersionPublishRunService,
  'finance.PlanView': planViewService,
  'finance.VatCode': vatCodeService,
  'forestry.Agreement': agreementService,
  'forestry.CalculationComponent': calculationComponentService,
  'forestry.CalculationTemplate': calculationTemplateService,
  'forestry.Contract': contractService,
  'forestry.CostType': costTypeService,
  'forestry.LoadObservation': loadObservationService,
  'forestry.Organization': organizationService,
  'forestry.PreCalculation': preCalculationService,
  'forestry.PriceAreaAssortment': priceAreaAssortmentService,
  'forestry.PriceDimension': priceDimensionService,
  'forestry.PriceDimensionClassCombination': priceDimensionClassCombinationService,
  'forestry.VolumeBasisLine': volumeBasisLineService,
  'forestry.Workorder': workorderService,
  'integration.ImportProfile': importProfileService,
  'integration.IntegrationCallRecord': integrationCallRecordService,
  'integration.IntegrationClient': integrationClientService,
  'integration.IntegrationConnection': integrationConnectionService,
  'integration.IntegrationJob': integrationJobService,
  'integration.IntegrationOutboxRecord': integrationOutboxRecordService,
  'integration.IntegrationRun': integrationRunService,
  'integration.IntegrationRunDetail': integrationRunDetailService,
  'integration.IntegrationRunError': integrationRunErrorService,
  'integration.IntegrationStagingRecord': integrationStagingRecordService,
  'inventory.InventoryOnHand': inventoryOnHandService,
  'inventory.InventoryPeriodClose': inventoryPeriodCloseService,
  'inventory.InventoryPostingProfile': inventoryPostingProfileService,
  'inventory.InventoryReservation': inventoryReservationService,
  'inventory.InventoryTransaction': inventoryTransactionService,
  'inventory.InventoryValueEntry': inventoryValueEntryService,
  'inventory.InventoryVarianceEntry': inventoryVarianceEntryService,
  'inventory.Product': productService,
  'inventory.StandardCostVersion': standardCostVersionService,
  'pricing.InternalPriceList': internalPriceListService,
  'pricing.PriceList': priceListService,
  'procurement.InboundMeasuringTicket': inboundMeasuringTicketService,
  'procurement.Supplier': supplierService,
  'sales.Customer': customerService,
  'sales.CustomerGroup': customerGroupService,
  'sales.Invoice': invoiceService,
  'sales.Order': orderService,
  'sales.OrderLine': orderLineService,
  'taskmanagement.WorkTask': workTaskService,
  'workflow.ApprovalDelegation': approvalDelegationService,
  'workflow.ApprovalPolicy': approvalPolicyService,
  'workflow.ApprovalRequest': approvalRequestService,
};

/**
 * Get service instance for an entity
 * @param module - Module name (e.g., 'sales', 'inventory')
 * @param entity - Entity name (e.g., 'Customer', 'Product')
 * @returns Service instance
 */
export function getServiceForEntity(module: string, entity: string): any {
  const key = `${module.toLowerCase()}.${entity}`;
  const service = serviceRegistry[key as keyof typeof serviceRegistry];

  if (!service) {
    throw new Error(
      `Service not found for ${module}.${entity}. Available services: ${Object.keys(serviceRegistry).join(', ')}`
    );
  }

  return service;
}

/**
 * Get all registered services
 */
export function getAllServices() {
  return serviceRegistry;
}
